import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import LoginPage from '../LoginPage';



class PrivateRoute extends React.PureComponent {
	render() {
		let auth = !!this.props.auth;

		if ( !auth ) {
			return <LoginPage />
		}

		return (
			<Route {...this.props} />
		)
	}

}



const mapStateToProps = state => {
	return {
		auth: state.auth.authenticated,
	};
};


export default connect( mapStateToProps )( PrivateRoute );

